@for (wrapper of messages; track wrapper.id) {
    <div class="messages">
        @if (!isMessageHidden()) {
            <div class="message message-sm message-{{ wrapper.message.severity.toUpperCase() }} {{ messageClass }}">
                <div class="text-break-word">
                    <span [innerHTML]="wrapper.message.message || (wrapper.message.messageKey | cxTranslate)"></span>
                    @if (wrapper.message.actionParams?.length > 0) {
                        @if (wrapper.message.action === 'moveToDate') {
                            &nbsp;
                            <button
                                class="btn-link text-underline text-default"
                                (click)="changeDate(wrapper.message.actionParams[1])">
                                {{ wrapper.message.actionParams[0] }}
                            </button>
                        }
                        @if (wrapper.message.action === 'changeQuantity') {
                            <button
                                class="ml-1 btn-link text-underline text-default"
                                (click)="updateQuantity(wrapper.message.actionParams[0])">
                                {{
                                    'order.warning.fullPackageSizeAction'
                                        | cxTranslate
                                            : {
                                                  quantity: wrapper.message.actionParams[0],
                                                  unit: entry.unit.name,
                                              }
                                }}
                            </button>
                        }
                        @if (wrapper.message.action === 'alternatives' || wrapper.message.action === 'crossSelling') {
                            @for (param of wrapper.getParams(); track param; let i = $index) {
                                <button
                                    class="btn-link btn-link-wrap text-bold ml-1"
                                    (click)="openProductModal(param.params[0])">
                                    {{ param.params[1] }}
                                </button>
                                <button
                                    class="btn-link ml-1"
                                    (click)="
                                        alternativeAction(param.params[0], wrapper.message.action === 'alternatives')
                                    ">
                                    <span class="text-underline text-default">{{ param.params[2] }}</span>
                                </button>
                                @if (i < wrapper.getParams().length - 1) {
                                    <span class="ml-1">/</span>
                                }
                            }
                            @if (wrapper.isShowMore()) {
                                <span class="ml-1">/</span>
                                <button class="btn-link btn-link-wrap text-bold ml-1" (click)="wrapper.toggle()">
                                    {{
                                        'order.message.showMore'
                                            | cxTranslate
                                                : {
                                                      remaining: wrapper.getRemainingParamSize(),
                                                  }
                                    }}
                                </button>
                            }
                        }
                        @if (wrapper.message.action === 'remove') {
                            &nbsp;
                            <button class="btn-link text-underline text-default" (click)="updateQuantity('0')">
                                {{ 'aimo.cart.removeProduct' | cxTranslate }}
                            </button>
                        }
                        @if (wrapper.message.action === 'orderTemplateAdded') {
                            &nbsp;<a class="link" (click)="openProductModal(wrapper.message.actionParams[1])">{{
                                wrapper.message.actionParams[0]
                            }}</a>
                            &nbsp;<span
                                >({{ wrapper.message.actionParams[2] }} {{ wrapper.message.actionParams[3] }} )</span
                            >
                            &nbsp;<span>{{ 'aimo.ordertemplate.addedToTemplateSuccessfully2' | cxTranslate }}</span>
                            &nbsp;
                            <button
                                class="btn-link"
                                [routerLink]="'/my-account/order-template/' + wrapper.message.actionParams[5]">
                                {{ wrapper.message.actionParams[4] }}
                            </button>
                        }
                        @if (wrapper.message.similarProducts) {
                            <span>
                                <span>&nbsp;{{ 'common.or' | cxTranslate }}&nbsp;</span>
                                <button
                                    class="btn-link"
                                    (click)="openProductModal(entry.product.code, 'similar-products-container')">
                                    <span class="text-underline">{{
                                        'aimo.product.lookSimilarProducts' | cxTranslate | lowercase
                                    }}</span>
                                </button>
                            </span>
                        }
                    }
                    @if (
                        wrapper.message.similarProducts &&
                        (!wrapper.message.actionParams || wrapper.message.actionParams?.length === 0)
                    ) {
                        <span>
                            &nbsp;
                            <button
                                class="btn-link"
                                (click)="openProductModal(entry.product.code, 'similar-products-container')">
                                <span class="text-underline">{{
                                    'aimo.product.lookSimilarProducts' | cxTranslate
                                }}</span>
                            </button>
                        </span>
                    }
                </div>
                @if (
                    (isWarningMessage(wrapper.message.severity) && showCloseIcon) ||
                    wrapper.message.action === 'alternatives' ||
                    wrapper.message.action === 'crossSelling'
                ) {
                    <i
                        (click)="hideMessage()"
                        class="aimo-icon icon-x icon-inline ml-auto icon-cursor icon-sm icon-petrol-blue"></i>
                }
            </div>
        }
    </div>
}
